import { AggregationRule } from "../../../lib/types/AggregationRule";

type IncomeRule = AggregationRule<"view">["ruleCondition"];
type ReturnedRule = AggregationRule<"createForm">["ruleCondition"];

/**
 * Преобразование ruleCondition JSON в массив для просмотра или редактирования
 * @param {IncomeRule} ruleCondition - строка приходящая с бэка
 * @return {ReturnedRule} массив ruleCondition
 */

export const parseRuleCondition = (ruleCondition: IncomeRule): ReturnedRule => {
  if (!ruleCondition) {
    return [{}];
  }
  try {
    const parsedRuleCondition = JSON.parse(String(ruleCondition));
    if (Array.isArray(parsedRuleCondition)) {
      return parsedRuleCondition;
    }
    console.log(`Неверный формат данных в ruleCondition: ${ruleCondition}`);
    return [{}];
  } catch {
    console.log(`Неверный формат данных в ruleCondition: ${ruleCondition}`);
    return [{}];
  }
};
